import React,{useRef,useEffect,useState,useCallback} from 'react';
import { alpha } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import Badge from '@mui/material/Badge';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import DeliveryPickAndPayment from './DeliveryPickAndPayment'
import LinearProgress from '@mui/material/LinearProgress';
import { createTheme } from "@mui/material";

import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";

import axios from 'axios'



const drawerWidth = 300;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const materialTheme = createTheme({
  // set default for now
});
const useStyles = makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
   
    appBarReviewOrder: {
      position: 'fixed',
    },
    appBarBottomReviewOrder: {
      top: 'auto',
      bottom: 0
    },
    titleBarReviewOrder: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    appBarTop: {
        [theme.breakpoints.up('sm')]: {
          width: `calc(100% - ${drawerWidth}px)`,
          marginLeft: drawerWidth,
        },
      },
      menuButton: {
        marginRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
          display: 'none',
        },
      },
  text: {
    padding: theme.spacing(2, 2, 0),
  },
  paper: {
    paddingBottom: 50,
  },
  list: {
    marginBottom: theme.spacing(2),
  },
  subheader: {
    backgroundColor: theme.palette.background.paper,
  },
  appBarBottom: {
    top: 'auto',
    bottom: 0,
    [theme.breakpoints.up('sm')]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
      },
  },
  grow: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
 

}));

const filter = createFilterOptions();
export default function Ordering(props) {
    const classes = useStyles();
    const [searchProductTerm, setSearchProductTerm] = useState({name:""});
    const [appBarWidth, setAppBarWidth] = useState(0);
    const elementRef = useRef(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [productFilter, setProductFilter] = useState(options[0]);
    const [autoSuggestProducts,setAutoSuggestProducts] = useState([])
    const [products,setProducts] = useState([]);
    const [totalItemOrdered,setTotalItemOrdered] = useState(0)
    const [totalOrderedAmount,setTotalOrderedAmount] = useState(0)
    const [openReviewDialog, setOpenReviewDialog] = useState(false);
    const [openDeliveryPickupAndPaymentDialog,setOpenDeliveryPickupAndPaymentDialog] = useState(false); 
    const [sellerCompanyId,setSellerCompanyId] = useState('200900')
    const [isLoading,setIsLoading] = useState(true)
    const [showMessageDialog,setShowMessageDialog] = useState(false)
    const [autoCompleteSearchOptionMessage,setAutoCompleteSearchOptionMessage] = useState("Searching...")
    const [messageDialogMessage,setMessageDialogMessage] = useState("")
    const [hasErrorFetchingProducts,setHasErrorFetchingProducts] = useState(false)
    const open = Boolean(anchorEl);
    const [hasMoreProductToLoad,setHasMoreProductToLoad] = useState(true)
    const [pageNumber,setPageNumber] = useState(1)
    const [loadProducts,setLoadProducts] = useState(true)

    const lastProductElementObserver = useRef()
    const lastProductElement = useCallback(node=>{
      if(isLoading){
          return
      }
      if(lastProductElementObserver.current){
        lastProductElementObserver.current.disconnect()
      }
      lastProductElementObserver.current = new IntersectionObserver(entries=>{
        if(entries[0].isIntersecting && hasMoreProductToLoad){
         
          lastProductElementObserver.current.disconnect()
          setPageNumber(prevPageNumber => prevPageNumber + 1)
          setLoadProducts(true)
        }

      })
      
      if(node){
        lastProductElementObserver.current.observe(node)
      }
    },[isLoading])
    
    

    //temporary storage
    const [tempOrderedProducts,setTempOrderedProducts] = useState([])


    const handleReviewDialogClickOpen = () => {

      if(totalItemOrdered <= 0){
        setMessageDialogMessage("Please input order.")
        setShowMessageDialog(true)
        return
      }
      setOpenReviewDialog(true);

    };
  
    const handleReviewDialogClose = () => {
      setOpenReviewDialog(false);
      fetchProducts(searchProductTerm.name)
    };

    const handleDeliveryPickupAndPaymentDialogOpen = ()=>{

      if(totalItemOrdered <= 0){
        setMessageDialogMessage("Please input order.")
        setShowMessageDialog(true)
        return
      }
      
      setOpenDeliveryPickupAndPaymentDialog(true)
    }
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
  
    const handleClose = () => {
      setAnchorEl(null);
    };

    const onOrderInputOnChange = (product,unit,quantity)=>{
    

      const newProducts = [...products]
    
      unit.order_quantity = quantity.length <=0  || isNaN(quantity) || quantity <=0 ? 0 : parseFloat(quantity).toFixed()

    
      product.total_order_value = computeTotalOrderPerProduct(product)
      

      saveOrDeleteLocalStorageTempOrder(product)

      setTotalItemOrdered(getTotalItemOrderedCount())
      setTotalOrderedAmount(computeOverallTotalOrderedAmount())
      setProducts(newProducts)
      
    }
    
  function computeTotalOrderPerProduct(product){
    
    const totalOrderValue = Number(product.Units.reduce((partialSum,unit)=> partialSum + parseFloat(unit.order_quantity) * unit.price_with_tax,0.00 ))

    
    return Number(totalOrderValue.toFixed(2))


  }
  function computeOverallTotalOrderedAmount(){
    const temporaryOrderString = localStorage.getItem("temporary_order")
     if(temporaryOrderString == null){
       return 0
     }
     const temporaryOrders = JSON.parse(temporaryOrderString)
     const overallTotalAmount = temporaryOrders.reduce((partialSum,product)=>partialSum + computeTotalOrderPerProduct(product),0.00).toFixed(2)
     
     return overallTotalAmount
     
  }

  function getTotalItemOrderedCount(){
    const temporaryOrderString = localStorage.getItem("temporary_order")
     if(temporaryOrderString == null){
       return 0
     }
     const temporaryOrders = JSON.parse(temporaryOrderString)

     const totalOrderedItems = temporaryOrders.reduce((productWithOrderPartialCount,product)=>{
       return productWithOrderPartialCount + product.Units.reduce((partialCount,unit)=>partialCount + (unit.order_quantity > 0 ? 1 : 0),0)
     },0)
     
     return totalOrderedItems
     
  }

  function saveOrDeleteLocalStorageTempOrder(product){
    const temporaryOrderString = localStorage.getItem("temporary_order")
     if(temporaryOrderString == null){
       localStorage.setItem("temporary_order",JSON.stringify([product]))
       return
     }
     const temporaryOrders = JSON.parse(temporaryOrderString)//JSON.parse(localStorage.getItem("temporary_order"))
     const index = temporaryOrders.findIndex(tempOrder => tempOrder.code == product.code && tempOrder.company_id== product.company_id)
     const totalOrder = computeTotalOrderPerProduct(product)
  
     if(index >=0){
       //update
       if(totalOrder > 0){
         temporaryOrders.splice(index,1,product) //replace object

       }else if(totalOrder <= 0){
         temporaryOrders.splice(index,1) //remove object
       }
     
     }else{
       if(totalOrder > 0){
         temporaryOrders.push(product)
       }
      
     }

     localStorage.setItem("temporary_order",JSON.stringify(temporaryOrders))
  }
  function closeAllDialogs(message){
    //Review dialog and delivery pickup and payment dialog
    setOpenReviewDialog(false)
    setOpenDeliveryPickupAndPaymentDialog(false)
    fetchProducts()
    
  }
  

  function autoComplete(){
       
    
    return (
      <Autocomplete
            value={searchProductTerm}
            noOptionsText={autoCompleteSearchOptionMessage}
            onChange={(event, newValue) => {
             
            
              if(newValue==null || newValue.name===""){
                searchProductTerm.name = ""
                return
              }
              searchProductTerm.name = newValue.name
              setProducts([])
              setPageNumber(1)
              setLoadProducts(true)
              //fetchProducts(newValue.name)
              
            }}
            
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            options={autoSuggestProducts}
            isOptionEqualToValue={(option, value) =>true}
            getOptionLabel={(option) => {
               
                  return option.name;
            }}
            renderOption={(props, option) => {
              return (
                <li {...props} key={option.name}>
                  {option.name}
                </li>
              );
            }}
            style={{ width: '100%',paddingLeft:'8px'}}
            renderInput={(params) => (
              <TextField
               {...params}
               variant='standard'  
               InputProps={{...params.InputProps, disableUnderline: true}}  
               
              onChange={(event)=>{ 
                setSearchProductTerm({name:event.target.value})
              
              }
              } />
            )}
          />
    );
    }

  function search(){
    return (
      <div position="static" style={{border:".1rem solid #989898",borderRadius:"4px",margin:'2px'}}>
          <Toolbar variant="dense" style={{padding:'0'}}>
              <Box flexGrow={1}>{autoComplete()}</Box>
              <Box>
              <IconButton 
                className={classes.margin} 
                size="large"
                onClick={()=>{
                  setProducts([])
                  setPageNumber(1)
                  setLoadProducts(true)
                }}>
              <SearchIcon />
              </IconButton>
              </Box>
          </Toolbar>
      </div>
    );
  }
  function productFilterOptions(){
    return(
            <Menu
            id="long-menu"
            anchorEl={anchorEl}
            getcontentanchorel={null}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            keepMounted
            open={open}
            onClose={handleClose}
            PaperProps={{
                style: {
                width:`${appBarWidth}px`,
                margin:"0px",
                padding:"0px"
                },
            }}
            >
            {options.map((option) => (
                <MenuItem key={option} selected={option === 'Pyxis'} onClick={handleClose}>
                {option}
                </MenuItem>
            ))}
            </Menu>)
     
  }

  function orderValue(unit){
      return unit.order_quantity <= 0 ? '':unit.order_quantity
  }

  function orderInput(product,unit){
    return(
      <Box display="flex" justifyContent="flex-end" >
        <Box p={1} display="flex" justifyContent="center"  flexDirection="column">
          <Typography variant="h6" component="span" style={{ fontWeight:600,fontSize:"16px" }}>{unit.price_with_tax} / <small>{unit.uom}</small></Typography>
        </Box>
        <Box p={1} style={{maxWidth:"100px"}}>
        <TextField
          id="outlined-size-small"
          variant="outlined"
          size="small"
          type="number"
          value = {orderValue(unit)}
          onChange={(event)=>{onOrderInputOnChange(product,unit,event.target.value)}}
        />
        </Box>
        
      </Box>
    )
  }

  function orderedProductOrderInput(product,unit){
    return(
      <Box display="flex" justifyContent="flex-end" >
        <Box p={1} display="flex" justifyContent="center"  flexDirection="column">
          <Typography variant="h6" component="span" style={{ fontWeight:600,fontSize:"16px" }}>{unit.price_with_tax} / <small>{unit.uom}</small></Typography>
        </Box>
        <Box p={1} style={{maxWidth:"100px"}}>
        <TextField
          id="outlined-size-small"
          variant="outlined"
          size="small"
          type="number"
          value = {orderValue(unit)}
          onChange={(event)=>{onOrderInputOnChange(product,unit,event.target.value)}}
        />
        </Box>
        
      </Box>
    )
  }
  function productElement(product){
    return (
      <Grid container style={{padding:"0px"}}>
        <Grid container item xs={12} >
          < Grid item xs={3} md={2} lg={1} style={{padding:"4px"}} container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center">
            <img src={product.image} alt="" style={{ width:"100%"}} />
          </Grid>
          <Grid item xs={9} md={10} lg={11}>
            <Grid 
            container
            direction="column"
            justifyContent="space-between"
            alignItems="stretch">
                <Grid item >
                  <Box style={{ fontWeight:600,fontSize:"14px" }}>{product.brand}</Box>
                  <Box  style={{ fontWeight:600,fontSize:"14px" }}>{product.name}</Box>

                </Grid>
                <Grid item >
                  {
                    product.Units.map(unit=>(
                        <React.Fragment key={unit.id} >
                       {orderInput(product,unit)}
                        </React.Fragment>
                      )
                    )
                  }
                  
                   
                </Grid>
                <Grid item style={{ fontWeight:600,fontSize:"14px",color:"red"}}>Available: {product.available_inventory} {product.available_inventory_unit}</Grid>
              <Grid item style={{ fontWeight:600,fontSize:"14px",color:"green"}}>Total : P {product.total_order_value == null || product.total_order_value.length <=0 ?"0.00" : product.total_order_value.toLocaleString(undefined, {minimumFractionDigits:2,maximumFractionDigits:2})}</Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }

  function orderedProductElement(product){
   
    return (
      <Grid container style={{padding:"0px"}}>
        <Grid container item xs={12} >
          < Grid item xs={3} md={2} lg={1} style={{padding:"4px"}} container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center">
            <img src={product.image} alt="safeguard" style={{ width:"100%"}} />
          </Grid>
          <Grid item xs={9} md={10} lg={11}>
            <Grid 
            container
            direction="column"
            justifyContent="space-between"
            alignItems="stretch">
                <Grid item >
                  <Box style={{ fontWeight:600,fontSize:"14px" }}>{product.brand}</Box>
                  <Box  style={{ fontWeight:600,fontSize:"14px" }}>{product.name}</Box>

                </Grid>
                <Grid item >
                  {
                    product.Units.map(unit=>(
                        
                        <React.Fragment key={unit.id} >
                      
                       {orderedProductOrderInput(product,unit)}
                        </React.Fragment>
                      )
                    )
                  }
                  
                   
                </Grid>
                <Grid item style={{ fontWeight:600,fontSize:"14px",color:"red"}}>Available: {product.available_inventory} {product.available_inventory_unit}</Grid>
              <Grid item style={{ fontWeight:600,fontSize:"14px",color:"green"}}>Total : P {product.total_order_value == null || product.total_order_value.length <=0 ?"0.00" : product.total_order_value.toLocaleString(undefined, {minimumFractionDigits:2,maximumFractionDigits:2})}</Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }

  function productLists(){
    return(
      <>
        {
          products.map((product,index)=>(
              (products.length  === index + 1) ?
              (
                <React.Fragment key={index+product.id+product.name} >
                  <ListItem ref={lastProductElement} key={index+product.id+product.name} divider >
                    {productElement(product)}
                  </ListItem>
                </React.Fragment>
               )
              :
              (
                <React.Fragment key={index+product.id+product.name}>
                  <ListItem key={index+product.id+product.name} divider >
                    {productElement(product)}
                  </ListItem>
               </React.Fragment>
              )
            )
          )
        }
      </>
    )
  }
  function orderProductLists(){
    return(
      <List>
        {
          tempOrderedProducts.map(product=>(
            <React.Fragment key={product.id+"order"}>
              <ListItem  divider >
                {orderedProductElement(product)}
              </ListItem>
              </React.Fragment>
            )
          )
        }
      </List>
    )
  }
  function orderReviewDialog(){
    return (
      <Dialog fullScreen open={openReviewDialog} onClose={handleReviewDialogClose} TransitionComponent={Transition}>
       
        <AppBar position="fixed" className={classes.appBarReviewOrder} >
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleReviewDialogClose}
              aria-label="close"
              size="large">
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.titleBarReviewOrder}>
              Order Review
            </Typography>
          </Toolbar>
        </AppBar>
        <div className={classes.appBarSpacer}></div>
        <div>
        {orderProductLists()}
        </div>
        <div className={classes.appBarSpacer}></div>
        <AppBar position="fixed" color="primary" className={classes.appBarBottomReviewOrder}>
        <Toolbar>
        <Typography variant="subtitle1" noWrap>
                    Total : {Number(totalOrderedAmount).toLocaleString(undefined, {minimumFractionDigits:2,maximumFractionDigits:2})}
          </Typography>
          <div className={classes.grow} />
         
          <Button variant="contained" onClick={handleDeliveryPickupAndPaymentDialogOpen}>
          <Typography variant="caption" noWrap>
            Checkout
          </Typography>
              
            <Badge badgeContent={totalItemOrdered} color="secondary" style={{marginLeft:"1rem"}}/>
          </Button>
          
        </Toolbar>
      </AppBar>
      </Dialog>
    );
  }

  function messageDialog(){
    return(
     
      <Dialog
      fullWidth={true}
      maxWidth={'sm'}
      open={showMessageDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{"Message"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
         {messageDialogMessage}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={()=>{
            setShowMessageDialog(false)
            }} 
          color="primary" autoFocus>
          Close
        </Button>
      </DialogActions>
    </Dialog>
    )
}
 
 
   



  useEffect(() => {

    if(!loadProducts){
      return
    }
    setAppBarWidth(elementRef.current.getBoundingClientRect().width);
    
    fetchProducts(searchProductTerm.name)

    
  }, [loadProducts]); //empty dependency array so it only runs once at render

  useEffect(()=>{
    if(searchProductTerm == null){
      
      fetchAutoSuggestProducts("")
    }else{
     
      //fetchProducts(searchProductTerm.name)
      fetchAutoSuggestProducts(searchProductTerm.name)
    }
    
  },[searchProductTerm])

  
  function fetchProducts(searchTerm){
    setIsLoading(true)
    setHasErrorFetchingProducts(false)
    
    const options = {
      method: 'POST',
      url: '/Products/products.json',
      data: objectToFormData({seller_company_id:sellerCompanyId,search_term:searchTerm,page_number:pageNumber})
    }
     axios(options)
       .then(res => {

        setIsLoading(false)
        setLoadProducts(false)
        
        const isSuccess = res.data.response.is_success
        if(!isSuccess){
          setMessageDialogMessage(res.data.response.message)
          setShowMessageDialog(true)
          setHasErrorFetchingProducts(true)
          
          //alert("Error encounter")
        }

        const productsFromServer = res.data.response.products
        const temporaryOrderString = localStorage.getItem("temporary_order")

        setHasMoreProductToLoad(productsFromServer.length > 0)
       
        if(temporaryOrderString == null){
          
          
          setProducts(products.concat(productsFromServer))
          setTotalItemOrdered(getTotalItemOrderedCount())
          setTotalOrderedAmount(computeOverallTotalOrderedAmount())

          return
        }
        const temporaryOrders = JSON.parse(temporaryOrderString)

        //check temporary orders
        productsFromServer.forEach((product,index)=>{
              getOrderPerProductInLocalStorage(temporaryOrders,product)
              product.total_order_value = computeTotalOrderPerProduct(product)
           
        })
       
        setTotalItemOrdered(getTotalItemOrderedCount())
        setTotalOrderedAmount(computeOverallTotalOrderedAmount())
       
        setProducts(products.concat(productsFromServer))
        
       }).catch(error => {

         //setShowProgress(false)
         console.log(error)
         setIsLoading(false)

       })
  }

  function fetchAutoSuggestProducts(searchString){
  

    const loadProducts = async () => {
        
        setAutoCompleteSearchOptionMessage("Searching")

        const options = {
          method: 'POST',
          url: '/Products/getProductsForAutoSuggest.json',
          data: objectToFormData({seller_company_id:sellerCompanyId,search_term:searchString})
        }
        const response = await axios(options)
          .then(res => {
            
            const products = res.data.products
            if(products.length <= 0){
              setAutoCompleteSearchOptionMessage("No record found.")
              setAutoSuggestProducts([])
            }else{
              setAutoSuggestProducts(products)
            }
           
          }).catch(error => {
    
            
    
          })
      }
      loadProducts()

    
  }
  useEffect(()=>{
    if(openReviewDialog == false){
      //do nothing
      return
    }


    const temporaryOrderString = localStorage.getItem("temporary_order")
    const temporaryOrders = JSON.parse(temporaryOrderString)
   
    setTempOrderedProducts(temporaryOrders)

  },[openReviewDialog])
  
  function getOrderPerProductInLocalStorage(temporaryOrders,product){

     const tempOrderIndex = temporaryOrders.findIndex(tempOrder => tempOrder.code == product.code && tempOrder.company_id== product.company_id)
   
     if(tempOrderIndex >= 0){
        product.Units.forEach((unit,index)=>{
          unit.order_quantity =  getOrderPerUomInLocalStorage(temporaryOrders[tempOrderIndex],unit)
            
        })
                
     }
     
  }
  function getOrderPerUomInLocalStorage(temporaryOrder,unit){
      const index = temporaryOrder.Units.findIndex(tempOrderUnit => tempOrderUnit.product_code == unit.product_code && tempOrderUnit.uom== unit.uom)
      if(index >=0){
        return temporaryOrder.Units[index].order_quantity
      }
      return 0

  }
  const objectToFormData = (object) => Object.keys(object).reduce((formData, key) => {
    formData.append(key, object[key]);
    return formData;
  }, new FormData());

  
  function orderingBody(){
    return(
      <React.Fragment>
      {productFilterOptions()}
      {search()}
      {isLoading ? <LinearProgress color="secondary"  style={{marginLeft:'.1rem',marginRight:'.1rem'}}/> : ''}
      <CssBaseline /> 
       {productLists()}
      </React.Fragment>
    )
  }
  return (
    <React.Fragment>
    <div>
            <CssBaseline />
            <AppBar position="fixed" className={classes.appBarTop} 
            aria-haspopup="true"
            onClick={handleClick}
            ref={elementRef}
            >
                <Toolbar>
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  edge="start"
                  onClick={props.handleDrawerToggle}
                  className={classes.menuButton}
                  size="large">
                    <MenuIcon />
                </IconButton>
                <Typography className={classes.title} variant="subtitle1">
                    {productFilter}
                </Typography>

                <IconButton aria-label="filter" color="inherit" size="large">
                    <MoreVertIcon />
                </IconButton>

                </Toolbar>
            </AppBar>
        </div>
          {hasErrorFetchingProducts ? "" :orderingBody()}
         
       <div className={classes.appBarSpacer}></div>
      <AppBar position="fixed" color="primary" className={classes.appBarBottom}>
      {loadProducts ? <LinearProgress color="secondary"  style={{marginLeft:'.1rem',marginRight:'.1rem'}}/> : ''}
        <Toolbar>
         <Typography variant="subtitle1" noWrap>
                Total : {Number(totalOrderedAmount).toLocaleString(undefined, {minimumFractionDigits:2,maximumFractionDigits:2})}
          </Typography>
          <div className={classes.grow} />
         
          <Button variant="contained" onClick={handleReviewDialogClickOpen}>
          <Typography variant="caption">
            Add to cart  
          </Typography>
            <Badge badgeContent={totalItemOrdered} color="secondary" style={{marginLeft:"1rem"}}/>
          </Button>
          
        </Toolbar>
      </AppBar>
       { orderReviewDialog()}
      <DeliveryPickAndPayment closeAllDialogs = {closeAllDialogs} sellerCompanyId={sellerCompanyId} openDeliveryPickupAndPaymentDialog={openDeliveryPickupAndPaymentDialog} setOpenDeliveryPickupAndPaymentDialog={setOpenDeliveryPickupAndPaymentDialog}/>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={materialTheme}> {messageDialog()}</ThemeProvider>
      </StyledEngineProvider>
     
    </React.Fragment>
  );
}


const options = [
  'All products',
  'Last ordered products',
  'Previously ordered (last 12 months)',
  'New products',
  'Promotions',
  'Suggested products',
  'Popular products',
  'Category',
  'Brand',
  'With order',
  
];
